import React, { Component } from 'react';

import LoadingSvg from '../../assets/svg/loading_blue.svg';

export default class Loading extends Component {
  render() {
    return (
        <div className="loading_grid">
            <img src={LoadingSvg} width={50} height={50}/>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Loading/index.js